import React, {useEffect, useState, useMemo} from 'react';
import CardMission from "components/card/mission";
import ApiDataBase from "server";
import UseContext from "hooks/useContext";
import EmptyStateCompany from "components/emptyState";
import {dateToEpoch} from "../../../helper/helper";
import {useOutletContext} from "react-router-dom";
import ScrollableTableWrapper from "components/table/components/ScrollableTableWrapper";

const InProgressContent = () => {
    const {companyData} = UseContext()
    const { searchValue = '', searchType = 'all' } = useOutletContext() || {};
    const [missions, setMissions] = useState([])
    const [isWaiting, setIsWaiting] = useState(true);

    // Charger les missions
    useEffect(() => {
        if (Object.keys(companyData).length) {
            setIsWaiting(true)
            ApiDataBase.getMissions({idC: companyData._id},
                (data) => {
                    // Filtrer les missions en cours directement
                    const now = dateToEpoch(new Date())
                    const inProgress = data.filter(mission => {
                        const start = dateToEpoch(new Date(mission.duration?.datestart))
                        const end = dateToEpoch(new Date(mission.duration?.dateend))
                        return now.getTime() >= start.getTime() && now.getTime() <= end.getTime()
                    }).reverse()
                    setMissions(inProgress)
                    setIsWaiting(false)
                },
                (err) => {
                    console.warn(err)
                    setIsWaiting(false)
                })
        }
    }, [companyData])

    // Filtrer les missions selon la recherche avec useMemo
    const filteredMissions = useMemo(() => {
        if (!searchValue) return missions;
        
        const searchLower = searchValue.toLowerCase();
        
        return missions.filter(mission => {
            const qualification = mission.qualification?.toLowerCase() || ''
            const title = mission.title?.toLowerCase() || ''
            const firstName = mission.userInfo?.[0]?.firstname?.toLowerCase() || ''
            const lastName = mission.userInfo?.[0]?.lastname?.toLowerCase() || ''
            const fullName = `${firstName} ${lastName}`.trim()
            const dateStart = mission.duration?.datestart ? new Date(mission.duration.datestart).toLocaleDateString('fr-FR').toLowerCase() : ''
            const dateEnd = mission.duration?.dateend ? new Date(mission.duration.dateend).toLocaleDateString('fr-FR').toLowerCase() : ''

            switch (searchType) {
                case 'mission':
                    return qualification.includes(searchLower) || title.includes(searchLower)
                case 'interimaire':
                    return fullName.includes(searchLower) || firstName.includes(searchLower) || lastName.includes(searchLower)
                case 'periode': {
                    const parsePeriodDates = (val) => {
                        if (!val || !val.trim()) return { start: null, end: null }
                        const parts = val.split('|')
                        const parseD = (str) => {
                            if (!str || !str.trim()) return null
                            const [d, m, y] = str.trim().split('/').map(Number)
                            if (!d || !m || !y) return null
                            return new Date(y, m - 1, d).getTime()
                        }
                        const start = parseD(parts[0])
                        const end = parts.length > 1 ? parseD(parts[1]) : null
                        return { start, end }
                    }
                    const { start: userStart, end: userEnd } = parsePeriodDates(searchValue)
                    const mStart = mission.duration?.datestart ? new Date(mission.duration.datestart).setHours(0, 0, 0, 0) : null
                    const mEnd = mission.duration?.dateend ? new Date(mission.duration.dateend).setHours(23, 59, 59, 999) : null
                    if (!mStart || !mEnd) return false
                    if (userStart && userEnd) {
                        return mStart <= userEnd && mEnd >= userStart
                    }
                    if (userStart) return userStart >= mStart && userStart <= mEnd
                    if (userEnd) return userEnd >= mStart && userEnd <= mEnd
                    return false
                }
                case 'motif':
                    const motifLabel = searchValue
                    return (
                        (motifLabel === "Accroissement temporaire d'activité" && mission.info_temporary_activity) ||
                        (motifLabel === "En attente de recrutement" && mission.awaiting_recruitement) ||
                        (motifLabel === "Remplacement d'un salarié absent" && mission.replacement_employee) ||
                        (motifLabel === "Contrat temporaire d'usage" && mission.temporary_contract) ||
                        (motifLabel === "Emploi à caractère saisonnier" && mission.seasonal_employment)
                    )
                case 'all':
                default:
                    return `${qualification} ${title} ${fullName} ${dateStart} ${dateEnd}`.includes(searchLower)
            }
        });
    }, [missions, searchValue, searchType]);

    return (
        <ScrollableTableWrapper className="p-4">
            <div className="flex flex-col gap-2 min-w-[1000px]">
            {isWaiting ? (
                [1, 2, 3, 4, 5].map((i) => (
                    <CardMission key={i} data={i} isWaiting={true}/>
                ))
            ) : (
                filteredMissions.length > 0 ? (
                    filteredMissions.map((item, index) => (
                        <CardMission key={item._id || index} data={item}/>
                    ))
                ) : (
                    missions.length === 0 ? (
                        <EmptyStateCompany type={'mission_in_progress'}/>
                    ) : (
                        <div className="text-center py-8 text-gray-500">
                            Aucune mission trouvée pour "{searchValue}"
                        </div>
                    )
                )
            )}
        </div>
        </ScrollableTableWrapper>
    );
};

export default InProgressContent;